import { Component, Input } from '@angular/core';
import { InvoiceItemModel } from 'app/models/invoice-item.model';
import { EventService } from '../../core/services/event.service';
import { ProviderBillService } from '../../services/provider-bill.service';
import { saveAs } from 'file-saver';
import { RegionType } from 'app/enums/region-type.enum';
import { DateFormatPipe } from 'ngx-moment';

@Component({
    selector: 'app-invoice-items-accordion',
    templateUrl: './invoice-items-accordion.component.html',
    styleUrls: ['./invoice-items-accordion.component.css'],
    standalone: false
})
export class InvoiceItemsAccordionComponent {

  public items: Array<InvoiceItemModel>;
  public RegionType = RegionType;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('items') public set update_items(data: Array<InvoiceItemModel>)
  {
    this.items = data;
    for(const item of this.items)
    {
      item.position = item.provider_category != null ? item.provider_category.position : 9999;
    }
  }

  constructor(private event_service: EventService, private provider_bill_service: ProviderBillService, private date_format_pipe:DateFormatPipe) {

  }

  PdfProviderBillExport(provider_bill_id: string) {
    this.event_service.loadingStart();
    this.provider_bill_service.GetProviderBillPDF(provider_bill_id).subscribe(
      file_model => {
        saveAs(file_model.url, file_model.file_name);
        this.event_service.loadingFinish();
      },
      error => {
        this.event_service.loadingFinish();
      });
  }

  public isEstimatedItem(item: InvoiceItemModel): boolean {
    if (!item)
      {return false;}

    return item.invoice_item_type.mapping === 'EstimatedBill';
  }
  public isProjectedItem(item: InvoiceItemModel): boolean {
    if (!item)
      {return false;}

    return item.invoice_item_type.mapping === 'ProjectedBill' || item.invoice_item_type.mapping === 'FinalProjectedBill';
  }
  public isResolutionItem(item: InvoiceItemModel): boolean {
    if (!item)
      {return false;}

    return item.invoice_item_type.mapping === 'ResolutionCredit' || item.invoice_item_type.mapping === 'FinalResolutionCredit';
  }

  public showDescriptionForItem(item:InvoiceItemModel): boolean {
    return !this.isEstimatedItem(item) && !this.isProjectedItem(item) && !this.isResolutionItem(item);
  }

  public providerNameForItem(item:InvoiceItemModel): string {
    if (!item)
      {return 'utility';}

    const provider = item.expected_bill?.provider;

    if (!provider)
      {return item.provider_category.name;}

    const provider_name = item.group?.region?.code === RegionType.NC && provider.legal_name ? provider.legal_name : provider.name;

    if (provider_name === '')
      {return item.provider_category.name;}

    return provider_name;
  }

  public billAmountLabelForItem(item:InvoiceItemModel): string {
    if (this.isEstimatedItem(item))
      {return 'Estimated Amount';}

    if (this.isProjectedItem(item))
      {return 'Projected Amount';}

    if (this.isResolutionItem(item))
      {return 'Projection Credit';}

    return 'Bill Amount';
  }

  public descriptionForItem(item:InvoiceItemModel): string {
    const usage_date_range = item.start_date && item.end_date ? this.date_format_pipe.transform(item.start_date, 'MMM D, YYYY') + ' - ' + this.date_format_pipe.transform(item.end_date, 'MMM D, YYYY') : '';
    const provider_name = this.providerNameForItem(item);

    let description = item.invoice_item_type.resident_description;

    if (description) {
      description = description.replace('{{usage_date_range}}', usage_date_range).replace('  ', ' ');
      description = description.replace('{{provider_name}}', provider_name).replace('  ', ' ');
      return description;
    }

    if (this.isEstimatedItem(item))
      {return 'This utility charge was estimated to expedite your move out process.';}

    if (this.isProjectedItem(item))
      {return 'This utility charge was projected based on previous utility data.';}

    if (this.isResolutionItem(item))
      {return 'This is credit for the utility projection on a previous bill.';}

    return '';
  }

  public headerBadgeTextForItem(item:InvoiceItemModel): string {
    if (this.isEstimatedItem(item))
      {return 'Estimated';}

    if (this.isProjectedItem(item))
      {return 'Projection';}

    if (this.isResolutionItem(item))
      {return 'Credit';}

    return '';
  }

  public tooltipForItem(item:InvoiceItemModel): string {
    return this.descriptionForItem(item);
  }

  public dateRangeForItem(item:InvoiceItemModel, format:string='MMM D, YYYY'): string {
    if (!item.start_date || !item.end_date)
      {return '';}

    let range = '';

    if (item.start_date)
      {range += this.date_format_pipe.transform(item.start_date, format);}

    if (item.start_date && item.end_date)
      {range += ' - ';}
    else if (!item.start_date && item.end_date)
      {range += 'as of ';}

    if (item.end_date)
      {range += this.date_format_pipe.transform(item.end_date, format);}

    return range;
  }

}
